const regexPhone = /^[\d\s+\-()]+$/;

// min and max are based on E.164 Standard, but requiring at least 8 characters
const MIN_PHONE_LENGTH = 8;
const MAX_PHONE_LENGTH = 15;

export const validatePhone = (phone: string) => {
  const phoneDigits = phone.replaceAll(/[^\d]/g, '');

  if (
    phoneDigits.length < MIN_PHONE_LENGTH ||
    phoneDigits.length > MAX_PHONE_LENGTH
  ) {
    return false;
  }

  return regexPhone.test(phone);
};
